module.exports = __webpack_public_path__ + "img/sort-numeric-up-alt.42d59f31.svg";